<template>
  <div class="content">
    <div class="cardContent">
      <div class="kxq">
        <div class="rowClass">
          <p>
            <span class="span-l">ICCID:</span><span class="span-r">{{cardData.iccid}}</span>
          </p>
          <p>
            <span class="span-l">IMSI:</span><span class="span-r">{{cardData.imsi}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.agent') }}:</span><span class="span-r">{{cardData.company}}</span>
          </p>
          <p>
            <span class="span-l">{{cardData.name}}:</span>
            <span class="span-r span-refresh">{{cardData.cardStatus}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.status') }}:</span><span class="span-r">{{cardData.showStatus}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.operator') }}:</span>
            <span class="span-r">{{cardData.operationName}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.cardSource') }}:</span><span class="span-r">{{cardData.cardSourceName}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.monthlyFlow') }}:</span>
            <span class="span-r span-refresh">{{cardData.monthFlow}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.internationalCardInfo.monthlyVoice') }}:</span>
            <span class="span-r span-refresh">{{cardData.monthVoice}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.internationalCardInfo.monthlySms') }}:</span>
            <span class="span-r span-refresh">{{cardData.monthSms}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.openAccountTime') }}:</span><span class="span-r">{{cardData.openTime}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.allocationTime') }}:</span><span class="span-r">{{cardData.lastAdminTransferTime}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.closeAccountTime') }}:</span><span class="span-r">{{cardData.delTime}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.packageActiveTime') }}:</span><span class="span-r">{{cardData.activeTime}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.packageExpireTime') }}:</span><span class="span-r">{{cardData.expireTime}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.internationalCardInfo.currentOperator') }}:</span>
            <span class="span-r">{{cardData.operatorCode}} </span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.internationalCardInfo.currentLocation') }}:</span><span class="span-r">{{cardData.country}} </span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">是否自动充值:</span><span class="span-r">
              {{cardData.autoCharge == 1?'是':'否'}}
              <span v-if="cardData.autoCharge == 1" style="margin-left: 20px;">{{cardData.autoProduct || ''}}</span>
            </span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">是否实名:</span><span class="span-r">
              {{cardData.kycStatus == 2?'已实名':'未实名'}}
            </span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">资源编码:</span><span class="span-r">
              {{cardData.internationalSourceKey}}
            </span>
          </p>
        </div>
        <div class="aloneClass">
          <p v-if="adminShow"><span class="span-l">{{ $t('app.cardDetail.levelDisplay') }}：</span><span class="span-r">{{cardData.companyNameLevel}}</span></p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.remarkDisplay') }}：</span>
            <span class="span-r">{{cardData.remark}}
              <span style="position: relative;top: -5px;cursor: pointer;" v-if="adminShow">
                <i class="el-icon-edit bianji-class" @click="editRow()"></i>
              </span>
            </span>
          </p>
          <p v-if="!adminShow">
            <el-button type="success" size="medium" v-hasPermi="['card:info:refresh']"  @click="refreshNow()">{{ $t('app.cardDetail.refreshNow') }}</el-button>
          </p>
        </div>
        <div class="operation-class" v-if="adminShow">
          <el-button type="success" size="medium" v-hasPermi="['card:info:international:refresh']"  @click="updateNow()">{{ $t('app.cardDetail.operation.immediateUpdate') }}</el-button>
          <el-button type="danger" v-if="cardData.showStatus == '待激活' || cardData.showStatus == '已激活' || cardData.showStatus == '预销户' ||cardData.showStatus == '已销户' " size="medium" v-hasPermi="['card:info:stopInternationalCard']" @click="closeCardStatus()">{{$t('app.cardDetail.operation.shutdown')}}</el-button>
          <el-button type="primary" v-else size="medium"  v-hasPermi="['card:info:activeInternationalCard']" @click="openCardStatus()">{{$t('app.cardDetail.operation.startup')}}</el-button>
        </div>
      </div>
    </div>
    <div class="cardContent marge-class">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane key="cardInternationalProduct" :label="$t('app.cardDetail.tabs.trafficPackageList')" name="cardInternationalProduct"  v-if="checkPermi(['card:info:cardProduct'])">
          <cardInternationalProduct ref="cardInternationalProductRef" :iccid="iccid" :channel="cardData.channel"></cardInternationalProduct>
        </el-tab-pane>
        <el-tab-pane key="voiceProduct" :label="$t('app.cardDetail.tabs.voicePackageList')" name="voiceProduct" v-if="cardData.channel == 'cmBrazil' && checkPermi(['card:info:cardVoiceProduct'])">
          <cardInternationalVoiceProduct ref="voiceProductRef" :iccid="iccid" :channel="cardData.channel"></cardInternationalVoiceProduct>
        </el-tab-pane>
        <el-tab-pane key="smsProduct" :label="$t('app.cardDetail.tabs.smsPackageList')" name="smsProduct" v-if="(cardData.channel == 'cmBrazil' || cardData.channel == 'Quadcell') && checkPermi(['card:info:cardSmsProduct'])">
          <cardInternationalSmsProduct ref="smsProductRef" :iccid="iccid" :channel="cardData.channel"></cardInternationalSmsProduct>
        </el-tab-pane>
        <el-tab-pane key="cardOrderList" :label="$t('app.cardDetail.tabs.orderList')" name="cardOrderList" v-if="checkPermi(['card:info:orderList'])">
          <cardOrderList ref="cardOrderListRef" :iccid="iccid"></cardOrderList>
        </el-tab-pane>
        <el-tab-pane key="operationList" :label="$t('app.cardDetail.tabs.operationList')" name="operationList" v-if="checkPermi(['card:info:operationList'])">
          <operationList ref="operationListRef" :iccid="iccid"></operationList>
        </el-tab-pane>
        <el-tab-pane key="remarkList" :label="$t('app.cardDetail.tabs.remarkList')" name="remarkList" v-if="checkPermi(['card:info:remarkList'])">
          <remarkList ref="remarkListRef" :iccid="iccid"></remarkList>
        </el-tab-pane>
        <el-tab-pane key="cardFlowMonth" :label="$t('app.cardDetail.tabs.monthlyTrafficQuery')" name="cardFlowMonth" :lazy = "true" v-if="checkPermi(['card:info:monthFlow'])">
          <cardMonthDetail ref="cardFlowMonthRef"  :iccid ="iccid" :operationName="cardData.operationName"></cardMonthDetail>
        </el-tab-pane>
        <el-tab-pane key="cardFlowDay" :label="$t('app.cardDetail.tabs.dailyTrafficQuery')" name="cardFlowDay" :lazy = "true" v-if="checkPermi(['card:info:dayFlow'])">
          <cardDayDetail ref="cardFlowDayRef" :iccid ="iccid" :operationName="cardData.operationName"></cardDayDetail>
        </el-tab-pane>
        <el-tab-pane key="cardSession" :label="$t('app.internationalCardInfo.tabs.trafficBillRecord')" name="cardSession"  v-if="checkPermi(['international:flow:record'])">
          <cardSession ref="cardSessionRef" :iccid ="iccid" :channel="cardData.channel"></cardSession>
        </el-tab-pane>
        <el-tab-pane key="voiceSession" :label="$t('app.internationalCardInfo.tabs.voiceBillRecord')" name="voiceSession" v-if="cardData.channel == 'cmBrazil' && checkPermi(['international:voice:record'])">
          <cardVoiceSession ref="voiceSessionRef" :iccid ="iccid"></cardVoiceSession>
        </el-tab-pane>
        <el-tab-pane key="smsSession" :label="$t('app.internationalCardInfo.tabs.smsBillRecord')" name="smsSession" v-if="cardData.channel == 'cmBrazil' && checkPermi(['international:sms:record'])">
          <cardSmsSession ref="smsSessionRef" :iccid ="iccid"></cardSmsSession>
        </el-tab-pane>
        <el-tab-pane key="cardInternationalProductExtral" :label="$t('app.internationalCardInfo.tabs.operatorPackageInfo')" name="cardInternationalProductExtral" v-if="(cardData.channel == 'cmlink' || cardData.channel == 'Quadcell') && checkPermi(['card:info:internationalProductExternal'])">
          <cardInternationalProductExtral ref="cardInternationalProductExtralRef" :iccid="iccid" :channel="cardData.channel"></cardInternationalProductExtral>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="备注" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="beizhu" ref="beizhu">
        <el-form-item label="备注内容:" prop="remark" label-width="100px">
          <el-input v-model="beizhu.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注内容"></el-input>
        </el-form-item>
        <el-form-item label="售后内容:" prop="saleRemark" label-width="100px">
          <el-input type="textarea" v-model="beizhu.saleRemark" autocomplete="off" style="width: 80%" placeholder="请输入售后内容"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog">取消</el-button>
        <el-button type="success" @click="saveDialog">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="限制使用国家"
      :visible.sync="dialogCountry"
      width="50%">
      <el-tag style="margin-right:10px;margin-bottom:10px;" v-for="(item,index) in countries" :key="index">{{item}}</el-tag>
    </el-dialog>
  </div>
</template>
<script>
import cardInternationalProduct from "@/components/cardDetails/cardInternationalProduct.vue";
import cardInternationalVoiceProduct from "@/components/cardDetails/cardInternationalVoiceProduct.vue";
import cardInternationalSmsProduct from "@/components/cardDetails/cardInternationalSmsProduct.vue";
import cardOrderList from "@/components/cardDetails/cardOrderList.vue";
import operationList from "@/components/cardDetails/operationList.vue";
import cardMonthDetail from "@/components/cardDetails/cardMonthDetail.vue";
import cardDayDetail from "@/components/cardDetails/cardDayDetail.vue";
import cardSession from "@/components/cardDetails/cardSession.vue";
import cardVoiceSession from "@/components/cardDetails/cardVoiceSession.vue";
import cardSmsSession from "@/components/cardDetails/cardSmsSession.vue";
import remarkList from "@/components/cardDetails/remarkList.vue";
import cardInternationalProductExtral from "@/components/cardDetails/cardInternationalProductExtral.vue";
import {
  cardDetail,
  syncRefreshMonthFlow,
  syncRefreshOnline
} from "@/api/api.js"; //卡详情的初始化数据
import { changeCardSyncStatus } from "@/api/api.js";//修改同步状态
import { syncCard } from "@/api/api.js";//立即更新
import { saveRemark , cardCountries} from "@/api/api.js"; //流量卡备注
import {closeInterCard,openInterCard} from "@/api/international.js";

export default {
  data() {
    return {
      iccid : undefined,
      activeName: "cardInternationalProduct",
      cardData:{},
      dialog:false,
      beizhu:{
        remark:"",
        saleRemark:""
      },
      dialogCountry:false,
      countries:[]
    };
  },
  computed: {
    adminShow () {
      return this.$store.getters.user.userType =='1'
    }
  },
  components: {
    cardInternationalProduct,
    cardInternationalVoiceProduct,
    cardInternationalSmsProduct,
    cardOrderList,
    operationList,
    cardMonthDetail,
    cardDayDetail,
    cardSession,
    cardVoiceSession,
    cardSmsSession,
    remarkList,
    cardInternationalProductExtral

  },
  methods: {
    handleClick(tab) {
      if (tab.name == "cardInternationalProduct") {
        if (this.$refs.cardInternationalProductRef) {
          this.$refs.cardInternationalProductRef.initData();
        }
      }else if(tab.name == "cardOrderList"){
        if (this.$refs.cardOrderListRef) {
          this.$refs.cardOrderListRef.initData();
        }
      }else if(tab.name == "operationList"){
        if (this.$refs.operationListRef) {
          this.$refs.operationListRef.initData();
        }
      }else if(tab.name == "remarkList"){
        if (this.$refs.remarkListRef) {
          this.$refs.remarkListRef.initData();
        }
      }else if(tab.name == "eighth"){
        if (this.$refs.cardIntegralListRef) {
          this.$refs.cardIntegralListRef.initData();
        }
      }else if(tab.name == "smsProduct"){
        if (this.$refs.smsProductRef) {
          this.$refs.smsProductRef.initData();
        }
      }else if(tab.name == "cardFlowMonth"){
        if (this.$refs.cardFlowMonthRef) {
          this.$refs.cardFlowMonthRef.initChart();
        }
      }else if(tab.name == "cardFlowDay"){
        if (this.$refs.cardFlowDayRef) {
          this.$refs.cardFlowDayRef.initChart();
        }
      }else if(tab.name == "voiceProduct"){
        if (this.$refs.voiceProductRef) {
          this.$refs.voiceProductRef.initData();
        }
      }else if (tab.name == "cardSession"){
        if (this.$refs.cardSessionRef) {
          this.$refs.cardSessionRef.initData();
        }
      }else if (tab.name == "voiceSession"){
        if (this.$refs.voiceSessionRef) {
          this.$refs.voiceSessionRef.initData();
        }
      }else if (tab.name == "smsSession"){
        if(this.$refs.smsSessionRef){
          this.$refs.smsSessionRef.initData();
        }
      }else if (tab.name == "cardInternationalProductExtral"){
        if (this.$refs.cardInternationalProductExtralRef) {
          this.$refs.cardInternationalProductExtralRef.initData();
        }
      }
    },
    openCardStatus() {
        this.$confirm('此操作将激活卡状态！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
        }).then(() => {
            openInterCard({iccid: this.iccid}).then((res) => {
                if (res.data.code == 200) {
                    this.$message({
                        title: "成功",
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                    });
                    this.initData();
                } else {
                    this.$message.error(res.data.message);
                }
            });
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    },
    closeCardStatus() {
        this.$confirm('此操作将会失效掉所有已生成状态的套餐，请谨慎操作！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
        }).then(() => {
            closeInterCard({iccid: this.iccid}).then((res) => {
                this.$message({
                    title: "成功",
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
                this.initData();
            });
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    },
    transferFlowRatio(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    Realnamestatus(status) {
      let obj = {
        0: "未实名 ",
        1: "实名中",
        2: "已实名",
        3: "未通过",
        4: "已注销",
      };
      return obj[status];
    },
    // 初始化数据
    initData() {
      let params ={
        iccid : this.iccid
      }
      cardDetail(params).then(res => {
        if(res.data.code == 200){
          this.cardData = res.data.data;
          this.cardData.kycStatus = this.Realnamestatus(this.cardData.kycStatus);
          this.cardData.sync = this.cardData.sync == "开启" ? "已开启" : "未开启";
          this.cardData.gprsStatus = this.cardData.gprsStatus == "开启" ? "已开启" : "未开启";
          this.cardData.speedStatus = this.cardData.speedStatus == 0 ? "未限速" : "已限速";
          this.cardData.monthFlow = this.cardData.monthFlow == null ? "无" : this.cardData.monthFlow + "M";
          this.cardData.remark = this.cardData.remark == null || this.cardData.remark == "" ? "无" : this.cardData.remark;
          this.cardData.openTime = this.cardData.openTime == null ? "无" : this.cardData.openTime;
          this.cardData.lastAdminTransferTime = this.cardData.lastAdminTransferTime == null ? "无" : this.cardData.lastAdminTransferTime;
          this.cardData.delTime = this.cardData.delTime == null ? "无" : this.cardData.delTime;
          this.cardData.activeTime = this.cardData.activeTime == null ? "无" : this.cardData.activeTime;
          this.cardData.expireTime = this.cardData.expireTime == null ? "无" : this.cardData.expireTime;
          this.cardData.phone = this.cardData.phone == null || this.cardData.phone == "" ? "无" : this.cardData.phone;
          this.cardData.company = this.cardData.company == null ? "未分配" : this.cardData.company;
          this.cardData.companyNameLevel = this.cardData.companyNameLevel == null ? "未分配" : this.cardData.companyNameLevel;
          this.cardData.imei = this.cardData.imei == null ? "无" : this.cardData.imei;
          this.cardData.hasAgreement = this.cardData.hasAgreement == 0 ? "未签约" : "已签约";
          switch (this.cardData.online) {
            case "online":
              this.cardData.online = "在线";
              break;
            case "offline":
              this.cardData.online = "不在线";
              break;
            case "unknown":
              this.cardData.online = "未查询到会话信息";
              break;
            case null:
              this.cardData.online = "未查询";
              break;
          }
          // 运营状态--运营商状态真的
          // 状态--公众号展示状态假的
          if(this.adminShow){
            this.cardData.name = '运营状态';
            this.cardData.cardStatus = this.transferFlowRatio(this.cardData.cardStatus);
            this.cardData.showStatus = this.transferFlowRatio(this.cardData.showStatus);
          }else{
            this.cardData.showStatus = this.transferFlowRatio(this.cardData.showStatus);
            this.cardData.name = 'IMSI';
            this.cardData.cardStatus = "无";
            this.cardData.cardSourceName = "无";
            this.cardData.gprsStatus = "已开启";
            if(this.cardData.hasEnjoy == "1"){
              this.cardData.monthFlow = "畅享"
            }
          };
        }
      })
    },
    // 备注的弹窗
    editRow(){
      this.dialog = true;
      this.beizhu ={};
      this.$set(this.beizhu,"remark",this.cardData.remark)
    },
    // 备注弹窗x
    dialogClose(){
      this.$refs.beizhu.clearValidate();
      this.dialog = false;
    },
    // 备注的取消按钮
    cancelDialog(){
      this.dialog = false;
    },
    // 备注的确认按钮
    saveDialog(){
      let params = {
        iccid:this.cardData.iccid,
        remark:this.beizhu.remark,
        saleRemark:this.beizhu.saleRemark
      };
      saveRemark(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.success("备注成功");
          this.dialog = false;
          this.beizhu = {};
          this.initData();
        }
      })
    },
    // 开关同步
    synchro(){
      let params = {
        iccid:this.iccid
      };
      if(this.cardData.sync == "已开启"){
        params.syncStatus = 0;
        changeCardSyncStatus(params).then(res =>{
          this.$message({
              message: '关闭同步成功',
              type: 'success'
            });
          this.initData();
        })
      }else{
        params.syncStatus = 1;
        changeCardSyncStatus(params).then(res =>{
          this.$message({
              message: '开启同步成功',
              type: 'success'
            });
          this.initData();
        })
      }
    },
    // 立即更新
    updateNow(){
      let params = {
        iccid:this.iccid
      }
      syncCard(params).then(res =>{
        this.$message({
            message: '立即更新成功',
            type: 'success'
          });
        this.initData();
      })
    },
    //刷新当月流量
    refreshMonthFlow() {
      let params = {
        iccid: this.cardData.iccid,
      };
      syncRefreshMonthFlow(params).then((res) => {
        this.$message({
          message: "刷新当月流量成功",
          type: "success",
        });
        this.initData();
      });
    },
    //刷新在线状态
    refreshOnline() {
      let params = {
        iccid: this.cardData.iccid,
      };
      syncRefreshOnline(params).then((res) => {
        this.$message({
          message: "刷新在线状态成功",
          type: "success",
        });
        this.initData();
      });
    },
    //刷新诊断结果
    refreshDiagnosticResults(){
      this.activeName = "ninth";
      this.$refs.diagnosticResultsRef.refreshDiagnosticData();
    },
    cardCountries(iccid){
      this.dialogCountry = true
      cardCountries({iccid}).then(res=>{
        this.countries = res.data.data
      })
    },
  },
  beforeRouteUpdate(to, from, next) {
    if(to.name == 'cardInternationalDetail' && to.query.iccid){
      if (to.query.iccid === this.iccid) {
        return next();
      }
      this.iccid =  to.query && to.query.iccid;
      this.initData();
    }
    next();
  },
  created() {
    this.iccid =  this.$route.query && this.$route.query.iccid;
    this.initData();
  },
  mounted() {
    if(!this.checkPermi(['card:info:cardProduct'])){
        this.activeName = 'smsProduct';
    } 
  },
};
</script>
<style scoped lang="less">
  .cardContent{
    padding: 0 20px;
  }
  .kxq{
    width: 100%;
    .rowClass{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      p{
        width: 33.3%;
        padding: 8px 0;
      }
    }
      .span-l{
        display: inline-block;
        width: 30%;
        text-align: left;
        font-size: 14px;
        color: #606266;
      }
      .span-r{
        display: inline-block;
        width: 70%;
        font-size: 14px;
        color: #1890ff;
      }
      .span-refresh{
        width: auto;
      }
      .span-refresh-btn{
        margin-left: 6px;
        font-size: 1.25rem;
        color: #67C23A;
      }
      .span-lock-unlock{
        font-size: 1.25rem;
        margin-left: 8px;
        color: #F56C6C;
      }
  }
  .aloneClass{
    p{
      padding: 8px 0;
    }
    .span-l{
      display: inline-block;
      width: 10%;
      text-align: left;
      font-size: 14px;
      color: #606266;
    }
    .span-r{
      display: inline-block;
      width: 90%;
      font-size: 14px;
      color: #1890ff;
    }
  }
  .operation-class{
    margin-top: 18px;
  }
  .marge-class{
    margin-top: 18px;
    padding-bottom:40px ;
  }
  @media screen and (max-width: 750px){
    .rowClass p{
      width: 100% !important;
    }
    .aloneClass p{
      .span-l{
        width: 30%;
      }
      .span-r{
        margin-left:10px
      }
    }
    .operation-class{
      .anniu{
        margin-left: 10px;
      }
      button{
        display: block;
        margin-top: 10px;
      }
    }
  }
  @media screen and (min-width: 750px) and (max-width: 1310px){
    .rowClass p{
      width: 50% !important;
    }
    .aloneClass p{
      .span-l{
        width: 15% !important;
      }
      .span-r{
        width:85% !important;
      }
    }
  }
</style>  